<template>
  <div class="k8m-header-dashboardTop">
    <div class="k8m-header-dropdown-container">
      <div class="k8m-header-dropdown-dashboard">
        <div class="k8m-container-in">
          <div class="heading">{{ selectCluster }} :</div>
          <RexSelectV3
            :showSearch="true"
            @onPopupScroll="scrollK8Instances"
            @onSearch="searchK8Instances"
            :value="selectedOption"
            :objectValueIndex="AppObjectIndex"
            @onChange="selectK8Instance"
            @onDropdownVisibleChange="onOpenSelectField"
            :searchPlaceholder="selectCluster"
            :boldActive="boldActive"
            width="15rem"
            :customStyle="{ width: '16rem' }"
            id="search-select-k8m-cluster"
          >
            <template #default>
              <RexSelectOption
                v-for="(obj, i) in getK8Clusters"
                :key="`${obj.key}-${i}`"
                :value="obj.label"
              >
                <RexTooltipV3
                  :title="obj.label"
                  placement="right"
                  class="k8-opt-tooltip"
                >
                  <div class="k8-opt-tooltip-text">
                    {{ obj.label }}
                  </div>
                </RexTooltipV3>
              </RexSelectOption>
              <RexSelectOption
                :disabled="true"
                v-if="isLoading"
                key="loading"
                :value="searchK8"
              >
                <div class="k8-loading-box">
                  <RexSpinV3 size="small" />
                </div>
              </RexSelectOption>
            </template>
          </RexSelectV3>
        </div>
      </div>
      <div class="k8m-header-dropdown-dashboard" v-if="!disableNamespace">
        <div class="heading">{{ selectNamespace }} :</div>
        <RexSelectV3
          :value="getCurrentK8Namespace.label"
          :objectValueIndex="AppObjectIndex"
          :customStyle="{ width: '16rem' }"
          @onChange="onK8NamespaceChange"
          :searchPlaceholder="selectNamespace"
          :heading="selectNamespace"
          :boldActive="boldActive"
          id="search-select-k8m-namespace"
        >
          <template #default>
            <RexSelectOption
              v-for="(obj, i) in getK8Namespaces"
              :key="`${obj.key}-${i}`"
              :value="obj.label"
            >
              {{ obj.label }}
            </RexSelectOption>
          </template>
        </RexSelectV3>
      </div>
      <div class="k8m-header-dropdown-dashboard" v-if="disableWorkloadType">
        <div class="heading">{{ selectWorkloads }} :</div>
        <RexSelectV3
          :value="getCurrentK8Workload"
          :objectValueIndex="AppObjectIndex"
          :customStyle="{ width: '16rem' }"
          @onChange="(value, option) => onK8WorkloadChange(value, option)"
          :searchPlaceholder="selectWorkloads"
          :heading="selectWorkloads"
          :boldActive="boldActive"
          id="search-select-k8m-workload"
        >
          <template #default>
            <RexSelectOption
              v-for="(obj, i) in workLoads"
              :key="`${obj.key}-${i}`"
              :value="obj.label"
            >
              {{ obj.label }}
            </RexSelectOption>
          </template>
        </RexSelectV3>
      </div>
      <div class="k8m-header-dropdown-dashboard" v-if="disableWorkload">
        <div class="heading">{{ getPlaceholder }} :</div>
        <RexSelectV3
          :data="getWorkloadData.selected"
          :value="getWorkloadData.current"
          :objectValueIndex="AppObjectIndex"
          :customStyle="{ width: '16rem' }"
          @onChange="onK8SelectedWorkloadChange"
          :searchPlaceholder="getPlaceholder"
          :heading="getPlaceholder"
          :boldActive="boldActive"
          id="search-select-k8m-deployment"
        >
          <template #default>
            <RexSelectOption
              v-for="(obj, i) in getWorkloadData.selected"
              :key="`${obj.key}-${i}`"
              :value="obj.label"
            >
              {{ obj.label }}
            </RexSelectOption>
          </template>
        </RexSelectV3>
      </div>
    </div>
    <ForecastToggle
      :showForecastToggle="getForecastTabs"
      @change="onForecastChange"
      :isForcastEnabled="isForcastEnabled"
      :disabled="!enabledAI"
    />
  </div>
</template>

<script>
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import graphQl from '@/services/graphQl';
import WSMTypes from '@/store/modules/wsm/wsmTypes';
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import * as types from '@/store/modules/k8/k8-types';
import {
  K8MutationType,
  WorkloadList,
  WorkloadPlaceholderList,
  HideNamespaceList,
} from '@/components/K8M/k8.types';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import {
  PAGE_SIZE_SCROLL,
  DEBOUNCE_DURATION,
  THROTTLE_DURATION,
} from '@/utils/constants';
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
import { K8_NAVTABS } from '@/utils/templates/k8mTemplate/k8m.constants';
import { parseServiceObjFromApplication } from '@/utils/helper-function';
import ForecastToggle from '@/components/IntegrationUtils/ForecastToggle.vue';
import RexSpinV3 from '@/rex-components/RexSpinV3.vue';
import { RexSelectOption } from '@/rex-components/rex.comp.config';
import RexTooltipV3 from '@/rex-components/RexTooltipV3.vue';
import { permissionTypes } from '@/router/constant';
import { notificationError } from '@/utils/notification';

export default {
  name: 'K8MHeader',
  components: {
    RexSearchSelect,
    ForecastToggle,
    RexSelectV3,
    RexSelectOption,
    RexTooltipV3,
    RexSpinV3,
  },
  data() {
    return {
      AppObjectIndex: 1,
      boldActive: false,
      enabledAI: false,
      selectNamespace: this.$t('k8.namespace'),
      selectCluster: this.$t('k8.cluster'),
      selectWorkloads: this.$t('k8.workloads'),
      hideNamespace: HideNamespaceList,
      showWorkload: [K8_NAVTABS.K8M_POD_TAB],
      workLoads: WorkloadList,
      showForecast: [K8_NAVTABS.K8M_CLUSTER_TAB],
      clusterTab: K8_NAVTABS.K8M_CLUSTER_TAB,
      nodeTab: K8_NAVTABS.K8M_NODE_TAB,
      serviceTab: K8_NAVTABS.K8M_SERVICE_TAB,
      selectInstance: this.$t('selectInstance'),
      selectService: this.$t('selectService'),
      selectEndpoint: this.$t('selectEndpoint'),
      servicesTotalPages: 1,
      servicesCurrentPage: 1,
      searchService: '',
      selectedOption: '',
      isLoading: false,
      services: [],
      searchK8: '',
    };
  },
  computed: {
    ...mapState('globalState', ['app']),
    ...mapState('k8State/k8CommonState', [
      'k8Statefulsets',
      'k8Daemonsets',
      'k8Deployments',
      'currentDep',
      'currentStatefulset',
      'currentDaemonset',
    ]),
    ...mapGetters('k8State/k8CommonState', [
      'getCurrentK8Tab',
      'getCurrentK8Workload',
      'getK8Clusters',
      'getCurrentK8Cluster',
      'getK8Namespaces',
      'getCurrentK8Namespace',
    ]),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapGetters('globalState/user', ['getTeamId']),
    getWorkloadData() {
      switch (this.getCurrentK8Workload.key) {
        case K8_NAVTABS.K8M_DEP_TAB:
          return {
            current: this.currentDep,
            selected: this.k8Deployments,
          };
        case K8_NAVTABS.K8M_STAT_TAB:
          return {
            current: this.currentStatefulset,
            selected: this.k8Statefulsets,
          };
        case K8_NAVTABS.K8M_DAEMON_TAB:
          return {
            current: this.currentDaemonset,
            selected: this.k8Daemonsets,
          };
        default:
          return {
            current: { key: 'all', label: 'All' },
            selected: [{ key: 'all', label: 'All' }],
          };
      }
    },
    getPlaceholder() {
      return WorkloadPlaceholderList[this.getCurrentK8Workload?.key];
    },
    disableNamespace() {
      return this.hideNamespace.includes(this.getCurrentK8Tab);
    },
    disableWorkloadType() {
      return this.showWorkload.includes(this.getCurrentK8Tab);
    },
    disableWorkload() {
      return (
        this.disableWorkloadType &&
        this.getCurrentK8Workload?.key !== 'all' &&
        this.getCurrentK8Workload?.key !== 'NONE'
      );
    },
    isForcastEnabled() {
      return this.app.isForcastEnabled;
    },
    getForecastTabs() {
      return this.showForecast.includes(this.getCurrentK8Tab);
    },
  },
  watch: {
    getDurationTime() {
      this.getK8ServicesAction({
        duration: this.getDurationTime,
        serviceReq: {
          capability: 'K',
        },
      });
    },
    getCurrentK8Tab() {
      if (!this.disableNamespace) {
        this.getK8NamespacesList();
      }
      if (
        this.getCurrentK8Tab === K8_NAVTABS.K8M_POD_TAB &&
        this.getCurrentK8Namespace.key !== 'all'
      ) {
        this.getK8WorkloadsList();
      }
    },
    getCurrentK8Workload() {
      if (this.getCurrentK8Workload.key !== 'all') {
        this.getK8WorkloadsList();
      }
    },
    getCurrentK8Namespace() {
      if (
        this.getCurrentK8Tab === K8_NAVTABS.K8M_POD_TAB &&
        this.getCurrentK8Workload.key !== 'all'
      ) {
        this.getK8WorkloadsList();
      }
    },
    getCurrentK8Cluster() {
      if (
        this.getCurrentK8Tab === K8_NAVTABS.K8M_POD_TAB &&
        this.getCurrentK8Workload.key !== 'all'
      ) {
        this.getK8WorkloadsList();
      }
      if (!this.disableNamespace) {
        this.getK8NamespacesList();
      }
    },
  },
  methods: {
    ...mapActions('k8State/k8CommonState', {
      getK8ServicesAction: 'GET_K8_CLUSTERS',
      getK8NamespacesAction: 'GET_K8_NAMESPACES',
      getK8WorkloadsAction: 'GET_K8_WORKLOADS',
    }),
    ...mapActions('globalState/settings', ['checkAIenable']),
    ...mapMutations('k8State/k8CommonState', [
      'setCurrentWorkload',
      'setCurrentValue',
      'setCurrentCluster',
      'setClusters',
    ]),
    ...mapMutations('globalState/app', ['setIsForcastEnabled']),
    ...mapMutations('globalState/user', {
      setTeamIdMutation: 'setTeamId',
    }),
    ...mapActions('globalState/app', ['toggleForecast']),
    ...mapMutations('globalState/settings', ['setIsCompareOptionsSelected']),
    onForecastChange(data) {
      this.setIsForcastEnabled(data);
      this.toggleForecast(data);
      this.setIsCompareOptionsSelected(false);
    },
    onK8WorkloadChange(value, option) {
      const formattedOption = {
        key: option.key.split('-')[0],
        label: option.value,
      };
      this.setCurrentWorkload(formattedOption);
    },
    async checkAI() {
      const params = {
        request: {
          teamId: this.getTeamId,
        },
      };
      const res = await this.checkAIenable(params);
      this.enabledAI = res.enabledAI;
    },
    onK8NamespaceChange(value, option) {
      this.setCurrentValue({
        type: K8MutationType[K8_NAVTABS.K8M_NAMESPACE_TAB],
        value: { key: option.key.split('-')[0], label: option.value },
      });
    },
    onK8ClusterChange(value, option) {
      this.setCurrentValue({
        type: K8MutationType[K8_NAVTABS.K8M_CLUSTER_TAB],
        value: { key: option.key, label: option.value },
      });
    },
    onK8SelectedWorkloadChange(value, option) {
      this.setCurrentValue({
        type: K8MutationType[this.getCurrentK8Workload.key],
        value: { key: option.key, label: option.value },
      });
    },
    getK8NamespacesList() {
      const params = {
        duration: this.getDurationTime,
        serviceId: this.getCurrentK8Cluster?.key,
        properties: [
          {
            key: 'instanceType',
            value: 'K8S_NAMESPACE',
          },
        ],
      };
      this.getK8NamespacesAction(params);
    },
    getParamProperties() {
      switch (this.getCurrentK8Workload?.key) {
        case K8_NAVTABS.K8M_DEP_TAB:
          return [
            {
              key: 'instanceType',
              value: 'K8S_DEPLOYMENT',
            },
          ];
        case K8_NAVTABS.K8M_DAEMON_TAB:
          return [
            {
              key: 'instanceType',
              value: 'K8S_DAEMON_SET',
            },
          ];
        case K8_NAVTABS.K8M_STAT_TAB:
          return [
            {
              key: 'instanceType',
              value: 'K8S_STATEFULSET',
            },
          ];
        default:
          return [];
      }
    },
    getK8WorkloadsList() {
      const props = this.getParamProperties();
      if (this.getCurrentK8Namespace.key !== 'all') {
        props.push({
          key: 'metaProperty1',
          value: this.getCurrentK8Namespace?.label,
        });
      }
      const params = {
        duration: this.getDurationTime,
        serviceId: this.getCurrentK8Cluster?.key,
        properties: props,
      };
      this.getK8WorkloadsAction(params);
    },
    onOpenSelectField(open) {
      if (open && this.searchK8) {
        this.servicesCurrentPage = 1;
        this.searchK8 = '';
        this.getK8Data();
      }
    },
    async getK8Data() {
      try {
        this.isLoading = true;
        const { data } = await this.getK8ServicesAction({
          duration: this.getDurationTime,
          keyword: this.searchK8 || '',
          serviceReq: {
            capability: 'K',
          },
          pagination: {
            pageNum: this.servicesCurrentPage,
            pageSize: PAGE_SIZE_SCROLL,
            needTotal: true,
          },
          permissions: [permissionTypes.READ, permissionTypes.WRITE],
        });
        const instancesData = data?.data?.services?.services;
        this.servicesTotalPages = Math.ceil(
          data?.data?.services?.total / PAGE_SIZE_SCROLL,
        );
        if (instancesData && Array.isArray(instancesData)) {
          if (!this.selectedOption) {
            this.selectedOption =
              this.getCurrentK8Cluster?.label || instancesData[0]?.label;
            this.setCurrentCluster(
              this.getCurrentK8Cluster?.key
                ? this.getCurrentK8Cluster
                : instancesData[0],
            );
          }
          this.setClusters(
            this.servicesCurrentPage === 1
              ? instancesData
              : [...this.getK8Clusters, ...instancesData],
          );
        }
        this.isLoading = false;
      } catch (error) {
        console.log('error', error);
        this.isLoading = false;
      }
    },
    scrollK8Instances: throttle(function (event) {
      const target = event.target;
      if (
        !this.isLoading &&
        target.scrollTop + target.offsetHeight >= target.scrollHeight - 10 &&
        this.servicesCurrentPage < this.servicesTotalPages
      ) {
        this.servicesCurrentPage += 1;
        this.getK8Data();
      }
    }, THROTTLE_DURATION),
    searchK8Instances: debounce(function (val) {
      this.servicesCurrentPage = 1;
      this.searchK8 = val;
      this.getK8Data();
    }, DEBOUNCE_DURATION),
    selectK8Instance(value, option) {
      this.selectedOption = value;
      const key = option.key?.split('-')?.[0];
      const selectedInstance = {
        key,
        label: option?.value,
        permissions: option?.metaProperty?.permissions,
      };
      this.setCurrentCluster(selectedInstance);
      if (this.searchK8) {
        this.searchK8 = '';
        this.servicesCurrentPage = 1;
        this.getK8Data();
      }
    },
  },
  async mounted() {
    this.getK8Data().catch((err) => {
      console.log(err);
    });
    this.selectedOption = this.getCurrentK8Cluster?.label;
    this.checkAI();
  },
};
</script>

<style lang="scss" scoped>
.k8m-header-dashboardTop {
  @include flex-center-justify(space-between);
  margin-top: 0.2rem;
  margin-right: 0.6235rem;
  //   border-bottom: 0.0625rem solid $line-separator;
  padding-bottom: 0.6875rem;
  min-height: 4rem;
}
.heading {
  margin-top: 0.3rem;
  font-size: 1.25em;
  color: $color-white;
  font-family: $semi-bold;
  margin-right: 0.5625em;
}
.k8m-container-in {
  display: flex;
}
.left {
  display: flex;
}
.k8m-header-dropdown-dashboard {
  margin-left: 0.1375rem;
  text-align: left;
  margin-right: 1.5rem;
  display: flex;
}
.k8-loading-box {
  @include flex-center;
  height: 100%;
  width: 100%;
}
.k8-opt-tooltip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.k8-opt-tooltip {
  overflow: hidden;
  white-space: nowrap;
}
.k8m-header-dropdown-container {
  display: flex;
}
</style>
